import React from 'react';
import { isMobile } from '@/biz/tool';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import {
  getPlatformAudienceTutorialScreenshot,
  getPlatformAudienceTutorialScreenshotStep
} from '@/biz/platform';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import ModalShowImage from '@/components/web/components/ModalShowImage';
import { useIsMobileMd } from '@/hooks/useIsMobileMd';

const ModalAnalysisAudienceTutorialScreenshot = ({
  platform
}: {
  platform?: string;
}) => {
  const { setShowModalShowImage } = useWebModalStore();
  const { detailData } = useDetailDataStore();
  const isMobileViewport = useIsMobileMd();
  const isMobileLayout = isMobile() || isMobileViewport;
  const audiencePlatform = platform ?? detailData?.order?.platform ?? '';

  const screenshotList = getPlatformAudienceTutorialScreenshot({
    platform: audiencePlatform
  });
  const screenshotStepList = getPlatformAudienceTutorialScreenshotStep({
    platform: audiencePlatform
  });

  return (
    <div className="self-stretch p-4 bg-[#f9f9fb] rounded-lg inline-flex flex-col justify-center items-start gap-6">
      <div className="justify-start text-[#60646c] text-sm font-normal font-['Inter']">
        Navigate to your channel’s analytics report and take screenshots. Please
        refer to the instructions below:
      </div>
      <div
        className={`self-stretch grid gap-2.5 min-h-[200px]
          ${isMobileLayout ? 'grid-cols-1 mb-20' : 'grid-cols-3 max-h-[calc(100vh-500px)] overflow-y-auto'}
        `}
      >
        {screenshotList?.map((url, index) => {
          return (
            <div
              key={index}
              className="inline-flex flex-col justify-center items-center gap-2.5"
            >
              <img
                alt={`screenshot-${index}`}
                onClick={() => {
                  setShowModalShowImage(true, url);
                }}
                className="w-full rounded-lg border border-[#d9d9e0] cursor-pointer"
                src={url}
              />
              <div className="text-center justify-start text-[#60646c] text-xs font-medium font-['Inter']">
                {screenshotStepList[index]}
              </div>
            </div>
          );
        })}
      </div>
      <ModalShowImage />
      {/*  */}
    </div>
  );
};

export default ModalAnalysisAudienceTutorialScreenshot;
